import { nanoid } from 'nanoid'
import NavBar from '../../components/NavBar'
import Navigation from './Navigation'
import Terms from './Terms'

export default function TermsAndConditions() {

    
    
  return (
    <div className='w-full scroll-smooth lg:flex flex-col h-screen'>
        <NavBar/>
        <div className="w-full relative flex flex-col lg:flex-row flex-1 h-full overflow-y-hidden">

            <Navigation />

            <main className="w-full px-6 lg:px-12 pt-8 lg:pt-16 lg:w-5/6 flex-1 overflow-auto h-full">

                <h1 id='eula' className="text-3xl font-bold text-left">
                    Terms And Conditions
                </h1>

                <h3 className="text-lg mt-8 uppercase">End user license agreement.</h3>
                <div className="text-gray-400">
                    Last updated: October 30, 2020
                </div>
                <p className='mt-4'>
                PigeonBolt &trade; App is licensed to You (End-User) by HodanHogan, located at Teshie-Nungua Estates, Accra, Ghana(hereinafter: Licensor), for use only under the terms of this License Agreement. By downloading the Application from the Apple AppStore / Google Playstore, and any update thereto (as permitted by this License Agreement), You indicate that You agree to be bound by all of the terms and conditions of this License Agreement, and that You accept this License Agreement. The parties of this License Agreement acknowledge that Apple is not a Party to this License Agreement and is not bound by any provisions or obligations with regard to the Application, such as warranty, liability, maintenance and support thereof. HodanHogan, , not Apple, is solely responsible for the licensed Application and the content thereof. This License Agreement may not provide for usage rules for the Application that are in conflict with the latest App Store Terms of Service. HodanHogan, acknowledges that it had the opportunity to review said terms and this License Agreement is not conflicting with them. 
                All rights not expressly granted to You are reserved.
                </p>

                <ol className="mt-8">
                    {
                        Terms.map((term)=>(
                            <li key={nanoid(5)} className='mt-8'>
                                <h5 id={term.title} className="text-lg font-bold inline-block capitalize">
                                    {term.title}
                                </h5>
                                <p className="mt-2">
                                    {term.content}
                                </p>
                            </li>
                        ))
                    }
                </ol>
                
            </main>

        </div>
    </div>
  )
}
